/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import React, { useState } from "react";
import {
  DefaultPageHeaderQuery,
  PageHeaderFragment,
} from "../../../graphql-types";
import RockitImage from "../image/image";
import Nav from "../nav/nav";
import { graphql, useStaticQuery } from "gatsby";
import CartButton from "../cart-button/cart-button";
import { StoreContext } from "../../context/store-context";
import Nav2 from "../nav/nav-2";
import MenuButton from "../buttons/menu-button.component";
import RockitLink from "../link/rockit-link";
import FlexCol from "../flex/flex";

export type PageHeaderProps = PageHeaderFragment;
export const PageHeader: React.FC<PageHeaderProps> = ({
  companyLogo,
  navigation,
  navigation2,
}) => {
  const { checkout, loading, didJustAddToCart } =
    React.useContext(StoreContext);

  const [isExpanded, toggleExpansion] = useState(false);


  console.log("checkout", checkout);

  const items = checkout ? checkout.lineItems : [];

  const quantity =  items.reduce((total, item) => {
    return total + item.quantity;
  }, 0);

  if (!companyLogo || !navigation) {
    const headerData =
      useStaticQuery<DefaultPageHeaderQuery>(query).contentfulSiteSettings;
    companyLogo = headerData.defaultHeader.companyLogo;
    navigation = headerData.defaultHeader.navigation;
  }
  return (
    <Box
      bg="gray"
      as="header"
      sx={{ position: "sticky", top:0, width: "100%", zIndex: 100 }}
    >
      <Flex
        bg="black"
        p={2}
        sx={{ justifyContent: "center", alignItems: "center", color: "white" }}
      >
        <a href="https://www.bloomhearing.com.au/en-au/news/important-security-update">
          Important Security Update. Learn More.
        </a>
      </Flex>

      <Flex
        py={[2]}
        variant="layout.box"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <RockitLink to="/">
          <RockitImage
            gatsbyImageData={companyLogo.gatsbyImageData}
            alt={"Logo"}
          />
        </RockitLink>
        <Box sx={{ display: ["block", "none"] }}>
          <CartButton quantity={quantity} />
        </Box>
        <Flex sx={{}}>
          <Box sx={{ display: ["inline", "none"] }}>
            <MenuButton
              open={isExpanded}
              onPress={() => toggleExpansion(!isExpanded)}
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              display: [isExpanded ? "block" : "none", "flex"],
              //position: "relative",
              //bg:"primary"
            }}
          >
            <Nav variant="main" navItems={navigation.navItems}></Nav>
          </Box>
        </Flex>
        <Box sx={{ display: ["none", "block"] }}>
          <CartButton quantity={quantity} />
        </Box>
      </Flex>
      {navigation2 && <Nav2 navItems={navigation2.navItems} />}
    </Box>
  );
};

export default PageHeader;

const query = graphql`
  query DefaultPageHeader {
    contentfulSiteSettings {
      defaultHeader {
        ...PageHeader
      }
    }
  }
`;
